import { noEffect, smokeEffect, fireEffect } from "./effects";

const logLevels_legacy = [
  { name: "Trace", colour: "#aaa", effect: noEffect },
  { name: "Debug", colour: "#00f", effect: noEffect },
  { name: "Information", colour: "#0f0", effect: noEffect },
  { name: "Warning", colour: "#fb0", effect: smokeEffect },
  { name: "Error", colour: "#f00", effect: fireEffect },
  { name: "Critical", colour: "#f0f", effect: fireEffect },
];

const logLevels = [
  { name: "Trace", colour: "#a7a7a8", effect: noEffect },
  { name: "Debug", colour: "#1d5b99", effect: noEffect },
  { name: "Information", colour: "#0bad54", effect: noEffect },
  { name: "Warning", colour: "#ffe603", effect: smokeEffect },
  { name: "Error", colour: "#d3190b", effect: fireEffect },
  { name: "Critical", colour: "#560909", effect: fireEffect },
];

export default logLevels;
